export default __webpack_public_path__ + "static/media/tuproyecto.468e2d63.jpg";